import toast from 'react-hot-toast';
import Modal from '~/components/Modal';
import { PriorInvestor } from '~/types/company';
import { withForm } from '~/utils/withForm';
import { useSubmitPortfolio } from '~/mutations/portfolio/useSubmitPortfolio';
import StandaloneProjectModal from './StandaloneProjectModal';
import SubmitPortfolioModal from './SubmitPortfolioModal';
import { useForm, usePortfolioContext } from '~/hooks';
import { useHistory } from 'react-router-dom';
import { PortfolioModalFormTypes } from '../PortfolioSubmissionButtons';

interface PortfolioModalProps {
  closeModal: () => void;
  currentForm: PortfolioModalFormTypes;
}

interface PortfolioSubmissionFormState {
  preferredInvestors: PriorInvestor[];
  preferredInvestorDetails: string;
  autoGrantDocAccess: boolean;
}

const defaults: PortfolioSubmissionFormState = {
  autoGrantDocAccess: true,
  preferredInvestors: [],
  preferredInvestorDetails: '',
};

const PortfolioSubmissionModal = withForm({ defaults }, ({
  closeModal,
  currentForm
}: PortfolioModalProps) => {
  const { id, updatePortfolioValue } = usePortfolioContext();
  const { formState } = useForm<PortfolioSubmissionFormState>();
  const history = useHistory();
  
  const { mutateAsync: submitPortfolio, status: submitPortfolioStatus } = useSubmitPortfolio();

  const handleSubmit = async () => {
    try {
      const projects = await submitPortfolio({ id, data: formState }) as any; 
      if (projects.revertStandaloneProject) {
        toast.success('Reverting to standalone project');
        // Redirect to standalone project
        history.push(`/project/${projects.revertStandaloneProject.id}`);
      } else {
        updatePortfolioValue('', {...formState, projects}, {doSave: false, patch: true});
        toast.success('Portfolio submitted successfully');
      }
      closeModal();
    } catch (error) {
      toast.error('Error submitting portfolio.');
    };
  };

  return (
    <Modal allowClose closeModal={submitPortfolioStatus === 'loading' ? undefined : closeModal}>
      {currentForm === 'STANDALONE_PROJECT' && (
        <StandaloneProjectModal handleSubmit={handleSubmit} closeModal={closeModal} />
      )}
 
      {currentForm === 'SUBMIT_PORTFOLIO' && (
        <SubmitPortfolioModal handleSubmit={handleSubmit} closeModal={closeModal} />
      )}
    </Modal> 
  );
});

export default PortfolioSubmissionModal;